import {Link, Route, Switch} from "wouter";
import Auth from "./pages/auth.tsx";
import Index from "./pages";
import useBrowserTheme from "./components/hooks/useBrowserTheme.ts";
import {useDocumentTitle} from "usehooks-ts";
import Icon from "./components/Icon.tsx";
import {FiLogOut} from "react-icons/fi";
import {useAccessToken} from "./components/hooks/useAccessToken.ts";
import {PrivacyPolicy, TermsOfConditions} from "./pages/extras/Legal.tsx";
import WorkspaceSelector from "./components/ui/WorkspaceSelector.tsx";
import React from "react";
import LazyPolotnoIndex from "./pages/polotno/LazyPolotnoIndex.tsx";
import AcceptInvite from "./pages/AcceptInvite.tsx";
import {setAccessToken} from "@/utils/api.ts";

function App() {
    useBrowserTheme();
    useDocumentTitle("Timely Turtle")

    return (<Switch>
        <Route path={"/editor"} component={LazyPolotnoIndex}/>
        <Route path={"/"} component={ComponentsWithNavbar} nest/>
    </Switch>
  )
}



function ComponentsWithNavbar(){
    if(new URL(window.location.href).searchParams.get("access_token")){
        setAccessToken(new URL(window.location.href).searchParams.get("access_token"))
        const without_access_token = new URL(window.location.href)
        without_access_token.searchParams.delete("access_token")
        window.history.replaceState({}, document.title, without_access_token.toString());
        // history.replaceState({}, document.title, window.location.pathname);
    }
    return <div>
        {/*<Navbar/>*/}
            <Switch>
            <Route path={"/legal/tos"} component={TermsOfConditions} />
            <Route path={"/legal/privacy"} component={PrivacyPolicy} />
            <Route path={"/invite/accept"} component={AcceptInvite} />
            <Route path={"/auth"} component={Auth} nest/>
            <Route path={"/"} component={Index} nest/>
        </Switch>
    </div>
}


function Navbar() {
    const {access_token} = useAccessToken();
    return <div className="p-2 border-bottom">
        <div className="container-fluid">
            <div className="row row-cols-3 align-items-center">
                <Link to={"/"} className="navbar-brand ps-3 align-items-center gap-3 d-inline-flex">
                    <Icon size={44}/>
                    <span className={"fs-5 d-lg-inline-block"} style={{marginTop: 6}}>Timely Turtle</span>
                </Link>
                {
                    access_token ?
                        <div className="d-flex justify-content-center">
                            <WorkspaceSelector/>
                        </div> : null
                }
                {
                    access_token ? <div className="text-end">
                        <Link to={"/logout"}
                              className={"btn btn-sm gap-1 d-inline-flex align-items-center btn-link text-secondary"}><FiLogOut/> Logout</Link>
                        </div> : null
                }
            </div>
        </div>
    </div>

}

export default App
